export const FREE_QUOTA_BUCKETS = {
  western: "zodiac",
  chinese: "zodiac",
  tarot: "tarot",
  wedding: "wedding",
};

export function getFreeQuotaBucket(feature) {
  return FREE_QUOTA_BUCKETS[feature] || null;
}

export function getRemainingFreeQuota(authUser, feature) {
  const bucket = getFreeQuotaBucket(feature);
  if (!bucket) return 0;

  const freeEntitlements = authUser?.freeEntitlements || {};
  const quota = freeEntitlements[bucket] || {};
  return Number(quota.remainingCount ?? quota.remaining_count ?? 0) || 0;
}

export function shouldShowFreeQuotaPopup(authUser, feature) {
  if (!authUser || authUser.activeSubscription || authUser.active_subscription) return false;
  return getRemainingFreeQuota(authUser, feature) > 0;
}

export function getFreeQuotaPopupCopy(feature, t) {
  const bucket = getFreeQuotaBucket(feature);
  if (bucket === "zodiac") {
    return {
      title: t("free_quota_popup_title_zodiac"),
      message: t("free_quota_popup_body_zodiac"),
      note: t("free_quota_popup_note_zodiac"),
    };
  }

  if (bucket === "tarot") {
    return {
      title: t("free_quota_popup_title_tarot"),
      message: t("free_quota_popup_body_tarot"),
      note: "",
    };
  }

  return {
    title: t("free_quota_popup_title_wedding"),
    message: t("free_quota_popup_body_wedding"),
    note: "",
  };
}
